import { intl } from '../../../../../../i18n'
import { TreeSelectWithSummary } from '../components/TreeSelectWithSummary'
import { useTeamSelectOptions } from './hooks/useTeamSelectOptions'
import { VersionReportVersionPageRowEntity } from '../../../../../../domain/entity/version-report/VersionReportVersionEntity'

type Props = {
  snapshotUuid: string
  value: string[]
  onChange: (value: string[]) => void
  multiSelect?: boolean
  height?: string
  rows?: VersionReportVersionPageRowEntity[]
}

export const TeamTreeSelect = ({
  snapshotUuid,
  value,
  onChange,
  multiSelect = true,
  height = '300px',
  rows,
}: Props) => {
  const { options, parentMap, isLoading } = useTeamSelectOptions({
    snapshotUuid,
  })

  return (
    <TreeSelectWithSummary
      options={options}
      parentMap={parentMap}
      value={value}
      onChange={onChange}
      multiSelect={multiSelect}
      height={height}
      loading={isLoading}
      rows={rows}
      placeholder={intl.formatMessage({
        id: 'versionReport.teamSelect.searchPlaceholder',
      })}
      summaryLabel={intl.formatMessage({
        id: 'versionReport.treeSelect.team.summaryLabel',
      })}
    />
  )
}
